import DateFnsUtils from "@date-io/date-fns";
import { InputLabel, MenuItem, TextField } from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { AuthContext } from "context/context";
import { parse } from "date-fns";
import { useContext, useEffect } from "react";
import { isTipoEndosoAvailable } from "shared/utils/endosoTypes";
import useStyles from "./styles";

const SelectSection = ({
  options = [],
  change,
  data,
  error,
  disableSelects,
}) => {
  const classes = useStyles();
  const { setTypeEnd } = useContext(AuthContext);

  useEffect(() => {
    if (data?.tipend) {
      setTypeEnd(data.tipend);
    }
  }, [data.tipend, setTypeEnd]);

  const fechaInicial =
    typeof data.fechainicial === "string"
      ? parse(data.fechainicial, "dd/MM/yyyy", new Date())
      : data.fechainicial;

  const availableOptions = options.filter((option) =>
    isTipoEndosoAvailable(option.idEndoso, data.ramo)
  );

  const handleSelectChange = (event) => {
    const selectedOption = availableOptions.find(
      (option) => option.idEndoso === event.target.value
    );
    if (!selectedOption) return;

    change({
      target: {
        name: "tipend",
        value: {
          idEndoso: selectedOption.idEndoso,
          descEndoso: selectedOption.descEndoso,
        },
      },
    });
  };

  return (
    <div className={classes.root}>
      <div className={classes.sections}>
        <InputLabel htmlFor="dateEndoso" className={classes.label}>
          Fecha del endoso
        </InputLabel>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            id="dateEndoso"
            size="small"
            inputVariant="outlined"
            format={"dd-MM-yyyy"}
            value={fechaInicial || null}
            error={error.date ? true : false}
            helperText={error.date || ""}
            disabled={disableSelects}
            onChange={(e) => {
              change({ target: { name: "fechainicial", value: e } });
            }}
          />
        </MuiPickersUtilsProvider>
      </div>
      <div className={classes.sections}>
        <InputLabel htmlFor="select" className={classes.label}>
          Tipo de endoso
        </InputLabel>
        <TextField
          id="select"
          name="tipend"
          variant="outlined"
          size="small"
          select
          error={error.select || error.maxHolders}
          helperText={error.select || error.maxHolders || ""}
          onChange={handleSelectChange}
          disabled={disableSelects}
          value={data.tipend || ""}
        >
          {availableOptions.map((option, index) => (
            <MenuItem key={index} value={option.idEndoso}>
              {option.idEndoso + " " + option.descEndoso}
            </MenuItem>
          ))}
        </TextField>
      </div>
    </div>
  );
};

export default SelectSection;
